<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p> {{obj.xbody}} </p>
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
            }
        },
        watch:{
            'obj.xid': function(){ 
                if( this.obj.xid == null ) return;
                this.$refs.alertar.reset(); 
                this.activo = true;
                // window.console.log( "MODALLLLLLLLLLLLLLLLll" ); 
            },
            'obj':function(){ 
                this.$refs.alertar.reset();
                this.activo = true;
            }
        },
        components:{Alertas},
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
            submit(){
                //window.console.log( "ZZZZ ",this.obj);
                var vue = this;
                if( vue.obj.xid == 31 ){ // andrea no debe ser eliminada
                    let men = { title: 'MENSAJE', body: 'Este usuario no puede ser eliminado o cambiado de estado.' };
                    this.$dialog.alert(men).then(function() {}).catch(function() {});
                    return;
                }
                vue.$refs.alertar.cargando();
                vue.activo = false;

                this.$apollo.mutate({
                    mutation: vue.obj.xsql,
                }).then(() => {
                    vue.$refs.alertar.success();
                    this.$emit('exito');
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
    
    }
</script>